import { render } from "./recruit.vue?vue&type=template&id=309cc2be&scoped=true"
import script from "./recruit.vue?vue&type=script&lang=js"
export * from "./recruit.vue?vue&type=script&lang=js"

import "./recruit.vue?vue&type=style&index=0&id=309cc2be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-309cc2be"

export default script